import React from "react";
import trans from "../../../../../utils";

export default function TrackedTableHead() {
	return (
		<div className="tracked-table-head">
			<div>{trans("Vehicle name")}</div>
			<div>{trans("status")}</div>
			<div>{trans("Actions")}</div>
		</div>
	);
}
